/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { LemmonModal } from "@lemmonhq/uikit";
import { RawPayment } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";
import { formatPrice } from "@lemmonhq/orders";
import { useAuth } from "@app/vue/providers/Auth";

interface VoidPaymentModalProps {
  onClose: () => void;
  payment: RawPayment;
  onSubmit: (paymentId: number) => Promise<void>;
}

export const VoidPaymentModal = defineComponent<VoidPaymentModalProps>({
  name: "VoidPaymentModal",
  props: ["onClose", "onSubmit", "payment"],
  setup(props) {
    const auth = useAuth();
    const loading = ref(false);

    const handleSubmit = async () => {
      try {
        loading.value = true;
        await props.onSubmit(props.payment.id);
      } catch (e) {
      } finally {
        loading.value = false;
      }
    };
    const { t } = useLocalization();
    return () => {
      const isCredit = props.payment.type === "credit";
      const title = isCredit
        ? t("reports.tx.void_payment.action_credit")
        : t("reports.tx.void_payment.action");

      return (
        <LemmonModal
          title={title}
          onClose={() => {
            props.onClose();
          }}
        >
          <div class="p-6 space-y-4">
            <div class="text-accent">
              <p class="mb-4">
                {isCredit
                  ? t("reports.tx.void_payment.confirm_credit")
                  : t("reports.tx.void_payment.confirm")}
              </p>
              <div class="bg-base-200 p-4 rounded-lg space-y-2">
                <div class="flex justify-between">
                  <span class="">{t("general.words.amount")}:</span>
                  <span class="font-semibold">
                    {formatPrice(
                      props.payment.amount,
                      true,
                      2,
                      auth.user.value?.restaurant.currency || "CHF",
                    )}
                  </span>
                </div>
                <div class="flex justify-between">
                  <span class="">{t("general.words.payment_method")}:</span>
                  <span class="font-semibold capitalize">
                    {props.payment.method}
                  </span>
                </div>
                <div class="flex justify-between">
                  <span class="">
                    {t("reports.tx.void_payment.transaction_id")}:
                  </span>
                  <span class="font-mono text-sm">{props.payment.id}</span>
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-2">
              <button class="btn btn-ghost" onClick={props.onClose}>
                {t("general.words.cancel")}
              </button>
              <button
                class="btn btn-error"
                onClick={handleSubmit}
                disabled={loading.value}
              >
                {loading.value
                  ? t("reports.tx.void_payment.submitting")
                  : title}
              </button>
            </div>
          </div>
        </LemmonModal>
      );
    };
  },
});
